<template lang="pug">
  .stock-relate
    .title 相关个股
    .section(v-for="item in list" :key="item.id")
      vant-row(type="flex" justify="space-between")
        vant-col(:span="5") {{item.name}}
        vant-col(:span="8") {{item.id}}
        vant-col.right.positive(:span="11") {{item.ratio |  parseValidRatio}}
</template>

<script>
import { Row, Col } from 'vant'
import { parseValidRatio } from '@utils/values'

export default {
  components: {
    VantRow: Row,
    VantCol: Col
  },
  /**
   * [
   *  {
   *    id: 股票code
   *    name: 个股名称
   *    victory: 上涨概率s
   *  }
   * ]
   *
   */
  props: {
    list: Array
  },
  filters: {
    parseValidRatio
  }
}
</script>

<style lang="stylus" scoped>
.stock-relate
  .title
    font-size 1.07rem
    font-weight 600
    margin-bottom 1.14rem
  .section
    border 1px solid #f9f9f9
    box-shadow #f9f9f9 0 0 1.07rem
    .van-row
      .van-col
        line-height 1.43rem
</style>
